import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AuthStore } from '@store';

import { environment } from '../../../../environments/environment';

import { GtmDirective } from '../../directives/gtm/gtm.directive';
import { ViNotificationComponent } from '../../../../projects/ui/components/notification/notification.component';

@Component({
  selector: 'app-downtime-notification',
  standalone: true,
  imports: [CommonModule, GtmDirective, TranslateModule, ViNotificationComponent],
  templateUrl: './downtime-notification.component.html',
  styleUrls: ['./downtime-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DowntimeNotificationComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  isGermanUser = false;
  isEnabled = environment.FEATURE.DOWNTIME_NOTIFICATION_ENABLED;

  constructor(public authStore: AuthStore) {}

  ngOnInit(): void {
    this.authStore
      .getCountryCode()
      .pipe(
        takeUntil(this.ngUnsubscribe),
        filter((code: string) => !!code)
      )
      .subscribe((code: string) => {
        this.isGermanUser = code.toUpperCase() === 'DE';
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
